import React from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import {
  Container,
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import PropertyRulesTable from "./PropertyRulesTable"
import "../../../../assets/scss/custom.scss"

const PropertyRule = props => {
  return (
    <>
      {
        <React.Fragment>
          <div className="page-content">
            <MetaTags>
              <title>Property | EEFind </title>
            </MetaTags>
            <Container fluid>
              <Breadcrumbs title="Property" breadcrumbItem="Property Rule" />
              <PropertyRulesTable
                queryCondition={null}
                activeFilters={null}
                filterQueryConditions={null}
                showCreateBtn={true}
              />
            </Container>
          </div>
        </React.Fragment>
      }
    </>
  )
}
PropertyRule.propTypes = {}
export default withRouter(PropertyRule)
